@if (visible()) {
  <span
    class="bdf-pill"
    [class.bdf-pill--md]="size() === 'sm'"
    [attr.data-state]="effectiveStatus()"
    [appTooltip]="effectiveTooltip()">
    <span class="bdf-pill__icon" aria-hidden="true">
      @switch (effectiveStatus()) {
        @case ('running') {
          <app-inline-spinner></app-inline-spinner>
        }
        @case ('done') {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
        }
        @case ('queued') {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        }
        @case ('error') {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg>
        }
        @default {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
          </svg>
        }
      }
    </span>
    <span class="bdf-pill__label" [attr.aria-hidden]="action() ? 'true' : null">
      @for (label of reservedLabels(); track label) {
        <span class="bdf-pill__reserve" aria-hidden="true">{{ label }}</span>
      }
      <span class="bdf-pill__text">{{ effectiveText() }}</span>
    </span>
    @if (action()) {
      <span class="bdf-pill__action">{{ effectiveText() }}, {{ action() }}</span>
    }
  </span>
}
